module.exports = __webpack_public_path__ + "videos/3d-model_en-hevc.225ea51.mp4";